export class CreateFeatureFlagDetailDto {
  constructor(data) {
    this.storeIds = data.storeIds;
    this.jobTitleIds = data.jobTitleIds;
    this.employeeIds = data.employeeIds;
  }
}
